









































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Heading from "../shared/Header.vue";
import { InvitationType } from "@/shared/api/userService";
import Input from "@/shared/components/ui/Input.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: { Heading, Input }
})
export default class Add extends Vue {
 userStore = useUserStore();
  notifierStore = useNotifierStore();
  emailAddress = "";
  firstName = "";
  lastName = "";
  phone = "";
  get isSubmitDisabled () {
    return this.$validator.errors.any();
  }

  onAdd () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }

      this.userStore.create({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.emailAddress,
        phone: this.phone,
        type: InvitationType.Admin
      })
        .then(_ => {
          this.notifierStore.setSuccess(
            `${encodeURI(this.firstName)}
            ${encodeURI(this.lastName)} has been added as an admin. An email has been sent to
            ${this.emailAddress} for confirmation`
          );
          this.firstName = "";
          this.lastName = "";
          this.emailAddress = "";
          this.phone = "";
        })
        .catch(response => {
          let err: any = response;
          if (
            response.response &&
            response.response.data &&
            response.response.data.errorMessage
          ) {
            err = response.response.data.errorMessage;
          }

          this.notifierStore.setDanger(err);
        });
    });
  }
}
